import { useContentShareControls, useContentShareState } from 'amazon-chime-sdk-component-library-react';
import React from 'react';

import ScreenShareIcon from '@mui/icons-material/ScreenShare';

import ControlButton from './control-button';
import { MeetingInfoContext } from '../../../../../context';

interface ContentShareButtonProps {
    showText?: boolean;
    disabled?: boolean;
}

export const ContentShareButton: React.FC<ContentShareButtonProps> = ({
    showText,
    disabled = false
}) => {

    const { showAnnotation } = React.useContext(MeetingInfoContext);

    const { isLocalUserSharing, tiles } = useContentShareState();
    const { toggleContentShare } = useContentShareControls();

    const changeContentShare = () => {
        toggleContentShare();
    }

    const getLabel = () => {

        if (showAnnotation) {
            return 'Cannot start content share while annotation is active';
        }

        if (tiles.length > 0) {

            if (isLocalUserSharing) {
                return 'Stop Content Share';
            }

            return `Can't start content share while other user is sharing`;
        }
        return 'Start Content Share';
    }

    const label = getLabel();

    return (
        <ControlButton
            disabled={disabled || showAnnotation || (tiles.length > 0 && !isLocalUserSharing)}
            activeIcon={<ScreenShareIcon color='action' />}
            inactiveIcon={<ScreenShareIcon color='action' />}
            active={isLocalUserSharing}
            onClick={changeContentShare}
            activeLabel={label}
            inactiveLabel={label}
            showText={showText}
        />
    );
};

export default ContentShareButton;